const initialState = {
  gift_card_credit: {
    remaining: 0
  },
  credit_note: {
    remaining: 0
  },
  coop_credit: {
    remaining: 0,
    percentage: 0
  },
  lms_points: {
    remaining: 0
  },
  budget: {
    remaining: 0
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_USER_CREDIT': {
      // ensure no values are less than zero
      const newState = { ...initialState, ...action.payload }
      Object.keys(newState).forEach(key => {
        if (newState[key].remaining < 0) {
          newState[key].remaining = 0
        }
      })
      return newState
    }
    case 'CLEAR_USER_CREDIT':
      return initialState
    default:
      return state
  }
}
